import React from 'react';
import { BooleanInput, TextInput, FormTab, ArrayInput, SimpleFormIterator, ImageInput, ImageField, FormDataConsumer, required } from 'react-admin';

import PictureTranslatableInputs from './inputs/PictureTranslatableInputs';

const CustomPictureTranslatableInputs = ({ record, ...props }) => {
	if (record?.image_url) {
		return <PictureTranslatableInputs record={record} {...props} />;
	}

	return null;
};

const PictureEditFormTab = (props) => (
	<FormTab label="Pictures" {...props}>
		<ArrayInput source="pictures" label="">
			<SimpleFormIterator disableReordering>
				<TextInput label="" source="id" type="hidden" style={{ display: 'none' }} />
				<FormDataConsumer>
					{({ getSource, scopedFormData, ...rest }) => {
						getSource();
						if (scopedFormData?.image_url) {
							return <ImageField source="image_url" record={scopedFormData} />
						}
						else {
							return (
								<ImageInput {...rest} label="Picture" source={getSource('picture_file')} accept="image/*" validate={[required()]}>
									<ImageField source="src" title="title" />
								</ImageInput>
							);
						}
					}}
				</FormDataConsumer>
				<TextInput label="Title" source="title" />
				<TextInput label="Description" source="description" />
				<TextInput label="Copyright" source="copyright" />
				<BooleanInput label="Main picture" source="featured" />

				<FormDataConsumer>
					{({ getSource, scopedFormData }) => {
						return <CustomPictureTranslatableInputs record={scopedFormData} source={getSource('').slice(0, -1)} />
					}}
				</FormDataConsumer>
			</SimpleFormIterator>
		</ArrayInput>
	</FormTab>
);

export default PictureEditFormTab;